import { ILuSelectCustomItem } from '../lu-select.models';
import LuSelectItem from './lu-select-item';

export class LuSelectCustomItem<T extends ILuSelectCustomItem> extends LuSelectItem {
	interface: T;

	constructor() {
		super();
	}
}
